import React, { FC, JSX, useEffect, useState } from 'react';
import Styles from './ProductTeaser.module.scss';
import Carousel from 'react-multi-carousel';
import { fetchOfferingDataV2 } from '../../services/LineTableService';
import { getFalconGradientClass, viewport } from '../../utils/utils';
import {
  DEFAULT_MOBILEPOSTPAID_BUNDLE,
  DEFAULT_WIRELINE_BUNDLE,
  FIXNET,
  MOBILE,
  NONE
} from '../../utils/constants';
import { Asset, FalconGradientTypes, GenericSBProps, Links } from '../types';
import { ProductTeaserPropConfig } from '../../services';
import ProductTeaserSlides from './ProductTeaserSlides';
import { clickEvent } from '../../Analytics/items';
import { TABCLICK } from '../../Analytics/AnalyticsConstants';

export interface RichTextWithTooltip extends GenericSBProps {
  icon: Asset;
  mobIcon: Asset;
  text: Array<Object>;
  tooltipTxt: string;
}
export interface ProductTeaserSlideSchema extends GenericSBProps {
  buttonLbl: string;
  conDuration: string;
  description: Array<Object>;
  desktopBGImage: Asset;
  details: RichTextWithTooltip[];
  heading: string;
  mobileBGImage: Asset;
  priceDesc: string;
  productId: string;
  productType: string;
  promoId: string;
  subHeading: string;
  summaryURL: Links;
  tabBGImage: Asset;
  tabTitle: string;
  tvDetails: RichTextWithTooltip[];
  tvPrice: string;
  tvProductId: string;
  tvSubHeading: string;
  textAlignment: any;
  gradientBackground: FalconGradientTypes;
  gradientBackgroundGlobal?: string;
  isFullWidthImage: boolean;
}

export interface ProductTeaserCompSchema extends GenericSBProps {
  btnIcon: Asset;
  serviceabilityError: string;
  tvIcon: Asset;
  productTeaserSlides: ProductTeaserSlideSchema[];
}

export interface ProductTeaserSchema {
  content: ProductTeaserCompSchema;
  lineCheckCallBack?: () => void;
  linecheckSuccessCallBack?: () => void;
  changeAddressClicked?: boolean;
  offerDataCallBack?: (a: any, b: any, c?: string) => void;
  productCallBack?: (a: string) => void;
  tableSelectedTab?: string;
  lineCheckOnClear?: () => void;
}

const ProductTeaser: FC<ProductTeaserSchema> = ({
  content,
  lineCheckCallBack,
  linecheckSuccessCallBack,
  offerDataCallBack,
  productCallBack,
  tableSelectedTab,
  lineCheckOnClear
}): JSX.Element => {
  const [offeringData, setOfferingData] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<any>('');
  const [enableToggle, setEnableToggle] = useState(false);
  const endPoint = ProductTeaserPropConfig?.getInstance()?.getBaseUrl();
  const viewPort = viewport();
  const normalizedGlobalGradient = content?.productTeaserSlides?.[0]?.gradientBackgroundGlobal
    ?.replace(/;\s*$/, '')
    ?.trim();
  const hasGlobalGradient =
    !!normalizedGlobalGradient && normalizedGlobalGradient.toLowerCase() !== NONE;
  const gradientStyle = !hasGlobalGradient
    ? getFalconGradientClass(content?.productTeaserSlides?.[0]?.gradientBackground)
    : '';
  const responsive = {
    desktop: {
      breakpoint: { max: 7000, min: 1440 },
      items: 1
    },
    tabletLarge: {
      breakpoint: { max: 1439, min: 1024 },
      items: 1
    },
    tabletMedium: {
      breakpoint: { max: 1023, min: 768 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1
    }
  };

  const CustomDot = (props: any) => {
    const { onClick, active, index } = props;
    active && setActiveTab(tabList[index]);
    return (
      <button
        className={active ? Styles.stageTeaserTabActive : Styles.stageTeaserTab}
        onClick={() => onClick()}
      >
        {tabList[index]}
      </button>
    );
  };
  const tabList = (content?.productTeaserSlides || [])?.map((tabs: any) => tabs?.tabTitle);

  //To track the tab switch
  const tabTrackEvent = (tabTitle: string) => {
    const title =
      (content?.productTeaserSlides || [])?.filter((slides) => slides?.tabTitle === tabTitle)?.[0]
        ?.heading ?? '';
    clickEvent(TABCLICK, title);
  };

  const CustomButtonGroupAsArrows = (props: any) => {
    return (
      <>
        {content?.productTeaserSlides?.length > 1 && viewPort !== MOBILE && (
          <div
            style={{
              textAlign: 'center'
            }}
          >
            <button
              disabled={props?.carouselState?.currentSlide === 0}
              className={Styles.leftArrow}
              onClick={props.previous}
            />
            <button
              disabled={props?.carouselState?.currentSlide + 1 === props?.carouselState.totalItems}
              className={Styles.rightArrow}
              onClick={props.next}
            />
          </div>
        )}
      </>
    );
  };

  const requestBody: any[] = [];
  (content?.productTeaserSlides || [])?.forEach((data: any, index: number) => {
    if (data?.productId && requestBody.filter((val) => val.id === data?.productId)?.length === 0) {
      requestBody.push({
        id: data?.productId,
        promoIds: [
          data?.promoId
            ? data?.promoId
            : data?.productType === FIXNET
              ? DEFAULT_WIRELINE_BUNDLE
              : DEFAULT_MOBILEPOSTPAID_BUNDLE
        ]
      });
    }

    if (
      data?.tvProductId &&
      requestBody.filter((val) => val?.id === data?.tvProductId)?.length === 0
    ) {
      requestBody.push({
        id: data?.tvProductId,
        promoIds: [data?.promoId ? data?.promoId : DEFAULT_WIRELINE_BUNDLE]
      });
    }
  });

  useEffect(() => {
    offeringData?.length === 0 &&
      fetchOfferingDataV2(requestBody, endPoint)
        .then((data: any) => {
          if (data && Object.keys(data)?.length > 0) {
            setOfferingData(data);
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log('error--->', error);
        });
  }, []);

  //UseEffect for stickyAnchor component
  useEffect(() => {
    const ProductTypee = content?.productTeaserSlides?.map((prod) => prod.productType);
    ProductTypee.map((prodd) => {
      if (
        Object.keys(offeringData)?.length == 1 &&
        typeof offerDataCallBack === 'function' &&
        prodd === MOBILE &&
        typeof productCallBack === 'function'
      ) {
        const promoId = requestBody?.[0]?.promoIds?.[0];
        const productId = requestBody?.[0]?.id;
        offerDataCallBack(offeringData[productId], promoId, activeTab);
        productCallBack(productId);
      } else if (
        Object.keys(offeringData)?.length > 1 &&
        typeof offerDataCallBack === 'function' &&
        prodd === MOBILE &&
        typeof productCallBack === 'function'
      ) {
        const promoId =
          requestBody?.filter((prod: any) => prod?.id === activeTab)?.[0]?.promoIds?.[0] ?? '';
        const productId = requestBody?.filter((prod: any) => prod?.id === activeTab)?.[0]?.id ?? '';
        offerDataCallBack(offeringData[activeTab], promoId, activeTab);
        productCallBack(productId);
      } else if (prodd === FIXNET) {
        content?.productTeaserSlides?.map((pId) => {
          const code: any = enableToggle ? pId?.tvProductId : pId?.productId;
          if (Object.keys(offeringData)?.length > 0 && typeof offerDataCallBack === 'function') {
            const promoId =
              requestBody?.filter((prod: any) => prod?.id === code)?.[0]?.promoIds?.[0] ?? '';
            offerDataCallBack(offeringData[code], promoId);
          }
        });
      }
    });
  }, [offeringData, activeTab, enableToggle]);

  //UseEffect to track tab switchs
  useEffect(() => {
    if (activeTab !== '') tabTrackEvent(activeTab);
  }, [activeTab]);
  return (
    <div
      className={`position-relative ${Styles.carouselContainer}`}
      style={hasGlobalGradient ? { background: normalizedGlobalGradient } : {}}
    >
      {content?.productTeaserSlides?.length > 0 && viewPort && (
        <Carousel
          responsive={responsive}
          autoPlay={false}
          shouldResetAutoplay={false} // this would stop auto play if next button is clicked
          showDots={content?.productTeaserSlides?.length === 1 ? false : true}
          customDot={<CustomDot />}
          dotListClass={Styles.carousel_dot}
          itemClass={Styles.carouselItem}
          ssr={true}
          arrows={false}
          containerClass={gradientStyle}
          sliderClass={Styles.sliderClass}
          customButtonGroup={<CustomButtonGroupAsArrows />}
          customTransition='transform 1s ease'
          transitionDuration={500}
        >
          {(content?.productTeaserSlides || [])?.map(
            (slide: ProductTeaserSlideSchema, index: number) => (
              <ProductTeaserSlides
                content={content}
                slides={slide}
                index={index}
                offeringData={offeringData}
                lineCheckCallBack={lineCheckCallBack}
                linecheckSuccessCallBack={linecheckSuccessCallBack}
                setEnableToggle={setEnableToggle}
                tableSelectedTab={tableSelectedTab}
                key={index}
                lineCheckOnClear={lineCheckOnClear}
              />
            )
          )}
        </Carousel>
      )}
    </div>
  );
};

export default ProductTeaser;
